<template>
  <div>
    <v-card v-if="!loadingGraph" :height="400">
      <v-card-text style="height: 150px">
        <ApexCharts
          ref="realtimeChart"
          class="apexchart"
          height="350"
          width="100%"
          :options="chartOptions"
          :series="series"
        />
      </v-card-text>
    </v-card>
    <v-card v-else :height="280">
      <v-card-text>
        <div class="d-flex justify-center align-center">
          <NoData />
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import NoData from '@/components/common/NoData.vue';
import UtilsDate from '@/utils/UtilsDate';
import ApexCharts from 'vue3-apexcharts';

export default {
  components: {
    NoData,
    ApexCharts,
  },

  props: {
    graphData: {
      type: Object,
      required: false,
    },

    loadingGraph: {
      type: Boolean,
      required: false,
    },
  },

  computed: {
    series() {
      return this.graphData?.series ?? [{ data: [] }];
    },

    chartOptions() {
      return {
        plotOptions: {
          bar: {
            columnWidth: '60%',
          },
        },

        chart: {
          id: 'graficoBarra',
          type: 'bar',
          defaultLocale: 'pt-br',
          locales: [
            {
              name: 'pt-br',
              options: {
                toolbar: {
                  show: false,
                  exportToSVG: 'Baixar SVG',
                  exportToPNG: 'Baixar PNG',
                  exportToCSV: 'Baixar CSV',
                  menu: 'Menu',
                  selection: 'Selecionar',
                  selectionZoom: 'Selecionar Zoom',
                  zoomIn: 'Aumentar',
                  zoomOut: 'Diminuir',
                  pan: 'Navegação',
                  reset: 'Reiniciar Zoom',
                },
              },
            },
          ],

          toolbar: {
            show: false,
          },
        },

        dataLabels: {
          enabled: false,
          style: {
            colors: ['#000000'],
          },
        },

        colors: ['#442D96', '#C73C44'],

        tooltip: {
          custom: ({ seriesIndex, dataPointIndex, w }) => {
            const initialSeries = w.globals.initialSeries[seriesIndex];
            const color = w.globals.colors[seriesIndex];
            const value = initialSeries.data[dataPointIndex];
            const perct = w.globals.seriesPercent[seriesIndex][dataPointIndex];

            return `
              <div class="apexcharts-tooltip__arrow-box">
                <div class="apexcharts-tooltip__dot" style="background: ${color}"></div>
                <span>${value} (${perct.toFixed(2)}%)</span>
              </div>
            `;
          },
        },

        xaxis: {
          categories: this.graphData?.keys || [],
          labels: {
            formatter(value) {
              return UtilsDate.format(value, 'MMM YYYY').toLocaleUpperCase();
            },
          },
        },

        title: {
          text: '',
          align: 'center',
          style: {
            color: '#011640',
          },
        },

        legend: {
          show: true,
          fontSize: 16,
          itemMargin: {
            horizontal: 16,
          },

          markers: {
            offsetX: -6,
            margin: 8,
            width: 12,
            height: 12,
            radius: 80,
          },
        },
      };
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep(.apexcharts-tooltip) {
  background-color: transparent;
  padding: 0;
}
</style>
